import React, { useState, useEffect, useRef } from "react";

export default function ProjektstatusNotar({ adminView, month, objekte, main, heading, notarTermine, userObjects }) {
   const [currentTermin, setCurrentTermin] = useState();
   const [seconds, setSeconds] = useState(0);
   const [countdowns, setCountdowns] = useState();
   const [jetzt, setJetzt] = useState(new Date());

   useEffect(() => {
      if (main) {
         setCurrentTermin(notarTermine.findIndex((item) => item.datum > new Date()));
      }
   }, []);

   function formatCountdown(myDatum, jetzt) {
      let timediff = myDatum - jetzt;
      if (timediff > 0) {
         let days = Math.floor(timediff / (1000 * 60 * 60 * 24));
         let hours = Math.floor((timediff % (1000 * 60 * 60 * 24)) / (1000 * 3600));
         let minutes = Math.floor((timediff % (1000 * 60 * 60)) / (1000 * 60));
         let seconds = Math.floor((timediff % (1000 * 60)) / 1000);
         /* 
            days +(days === 1 ? " Tag " : " Tage ") +
                  hours.toString().padStart(2, "0") +
                  ":" +
                  minutes.toString().padStart(2, "0") +
                ":" +seconds.toString().padStart(2, "0") */
         return (
            (days ? days + (days === 1 ? " Tag " : " Tage ") : "🌟🌟🌟") +
            hours.toString().padStart(2, "0") +
            ":" +
            minutes.toString().padStart(2, "0") +
            (true ? ":" + seconds.toString().padStart(2, "0") : "") +
            (days ? "" : "🌟🌟🌟")
         );
      } else {
         return "";
      }
   }

   useEffect(() => {
      const interval = setInterval(() => {
         setJetzt(new Date());
      }, 1000);
      return () => clearTimeout(interval);
   }, []);

   return (
      <>
         <div className="projektstatus-l2" style={{ flexGrow: 15 }}>
            <h2>
               <small>Notar</small> {heading} {" | "} {notarTermine.length}
               {adminView && (
                  <div style={{ fontSize: "22px" }}>
                     <span title="abgeschlossener Umsatz">
                     {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     }).format(
                        notarTermine.reduce(
                           (oldObj, item) =>
                              oldObj + (objekte[item.id] && item.datum < jetzt ? objekte[item.id].umsatz : 0),
                           0
                        )
                     )}</span>
                     {" | "}
                     <small title="gesamter Umsatz">
                        {new Intl.NumberFormat("de-DE", {
                           style: "currency",
                           currency: "EUR",
                           minimumFractionDigits: 2,
                           maximumFractionDigits: 2,
                        }).format(
                           notarTermine.reduce(
                              (oldObj, item) => oldObj + (objekte[item.id] ? objekte[item.id].umsatz : 0),
                              0
                           )
                        )}
                     </small>
                  </div>
               )}
            </h2>
            {notarTermine &&
               notarTermine.map((nTermin, index) => (
                  <a
                     href={
                        nTermin.benutzer && nTermin.benutzer.length
                           ? `https://smart.onoffice.de/smart/smart.php?modul_name=kalender&inhalt=kalender&Ansicht=Arbeitswoche&AnsichtArt=benutzerGruppe&AnsichtBenutzer=${nTermin.benutzer[0].userName}&jahr=${nTermin.datum.getFullYear()}&monat=${nTermin.datum.getMonth() + 1}&tag=${nTermin.datum.getDate()}`
                           : objekte[nTermin.id]
                             ? "/datenblatt?estateid=" + nTermin.id
                             : null
                     }
                     // href={objekte[nTermin.id] ? "/datenblatt?estateid=" + nTermin.id : null}
                     title={objekte[nTermin.id] ? objekte[nTermin.id].objektnr_extern : "keine Immobilie im Termin verknüpft"}
                     target="_blank"
                     rel="noopener noreferrer"
                     className={
                        "projektstatus-notartermin " +
                        (main && index === currentTermin
                           ? "current-notartermin"
                           : main && nTermin.datum.getDate() - new Date().getDate() === 0
                             ? " today-notartermin"
                             : "")
                     }
                     style={{
                        opacity: nTermin.datum > jetzt ? 1 : 0.85,
                        backgroundColor: objekte[nTermin.id] ? "" : "#faa",
                     }}
                     key={"ntermin_" + nTermin.id + "_" + index}
                  >
                     {nTermin.datum > jetzt && (
                        <span className="projektstatus-countdown">{formatCountdown(nTermin.datum, jetzt)} </span>
                     )}
                     <div className="projektstatus-datum">
                        {"("}
                        {nTermin.datum.toLocaleDateString()},{" "}
                        {nTermin.datum.toLocaleTimeString([], {
                           timeStyle: "short",
                        })}{" "}
                        Uhr{")|"}
                        {userObjects && (
                           <span style={{ fontSize: "12px" }}>
                              {" "}
                              {nTermin.benutzer
                                 .map((benutzerin) => {
                                    return benutzerin.firstName[0] + ". " + benutzerin.lastName;
                                 })
                                 .join(", ")}
                              {" | "}
                              {nTermin.subject
                                 .replace("Notartermin", "")
                                 .replace("Uhr", "")
                                 .replace(/[0-9]/g, "")
                                 .replace(":", "")
                                 .replace("Notar", "NT")}
                           </span>
                        )}
                     </div>
                     {adminView && (
                        <div>
                           {objekte[nTermin.id] && (
                              <span>
                                 {" "}
                                 {"VK: "}
                                 {new Intl.NumberFormat("de-DE", {
                                    style: "currency",
                                    currency: "EUR",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 }).format(objekte[nTermin.id].verkauft_fur)}
                                 {" U: "}
                                 {new Intl.NumberFormat("de-DE", {
                                    style: "currency",
                                    currency: "EUR",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 }).format(objekte[nTermin.id].umsatz)}
                              </span>
                           )}
                        </div>
                     )}
                  </a>
               ))}
         </div>
      </>
   );
}
